import React, { useEffect, useState } from 'react'
import { imageExists } from '../../../utils/helpers'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faImagePolaroid } from '@fortawesome/pro-light-svg-icons'
import { IconDefinition } from '@fortawesome/fontawesome-svg-core'

const ExternalImage = ({
	url,
	fallbackIcon,
	...restProps
}: {
	url: string
	fallbackIcon?: IconDefinition
	[key: string]: any
}) => {
	const [img, setImg] = useState(null)

	useEffect(() => {
		if (url) {
			imageExists(
				url,
				() => {
					setImg(url)
				},
				() => {
					setImg(null)
				}
			)
		} else {
			setImg(null)
		}
	}, [url])

	return img ? (
		<img src={img} alt="Image" {...restProps} />
	) : (
		<span className="flex w-full h-full items-center justify-center">
			<FontAwesomeIcon
				{...restProps}
				icon={fallbackIcon || faImagePolaroid}
				size="lg"
				className="text-gray-600 text-xl"
			/>
		</span>
	)
}

export default ExternalImage
